import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import DatePickerSF from '../../../widgets/input/DatePickerSF'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CashFlowDownloadModalSF from './CashFlowDownloadModalSF'
import ClientWiseSummaryDownloadModalSF from './ClientWiseSummaryDownloadModalSF'
import './NodalCashFlow.css'

const NodalCashFlowUI = ({ context, onRefreshClick, accountNumber, cashFlow,
  climeTypeInflowList, climeTypeOutflowList, txnTypeInflowList, txnTypeOutflowList,
  downloadMode, onDownloadClick, onDownloadCancel,
  downloadCFMode, onDownloadCFClick, onDownloadCFCancel,
  startDate, onStartDateChange, endDate, onEndDateChange, onSubmit
}) =>
  <div className='su_ncf'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          onSubmit={onSubmit}
        />
      }
    />

    <div className='g_flex_h g_flex_right'>
      <LinkWithSpinnerUI className='g_m_right g_m_bottom_25' label='Download cash flow'
        onClick={onDownloadCFClick} busy={downloadCFMode} spinnerOnLeft={true}
      />
      <LinkWithSpinnerUI className='g_m_right g_m_bottom_25 g_m_left_50' label='Download client-wise summary'
        onClick={onDownloadClick} busy={downloadMode} spinnerOnLeft={true}
      />
    </div>

    <CardUI className='g_m_top_100'>
      <table>
        <tbody>
          <tr><td colSpan='2'><b>Opening Balances</b></td></tr>
          {
            cashFlow &&
            <>
              <tr>
                <td className='name g_no_wrap_2'>FDs</td>
                <td className='amt g_text_right'>{cashFlow.openingFdF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Bank statements</td>
                <td className='amt g_text_right'>{cashFlow.openingBalanceF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Restricted balance</td>
                <td className='amt g_text_right'>{cashFlow.openingRestrictedBalanceF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Unrestricted DSRA</td>
                <td className='amt g_text_right'>{cashFlow.openingUnrestrictedDSRAF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Unrestricted others</td>
                <td className='amt g_text_right'>{cashFlow.openingUnrestrictedOthersF4}</td>
              </tr>
            </>
          }
          <tr><td colSpan='2'>&nbsp;</td></tr>
          <tr><td colSpan='2'><b>Add: Non-escrow Inflows</b></td></tr>
          {
            climeTypeInflowList && climeTypeInflowList.map((txn) =>
              <tr>
                <td className='name g_no_wrap_2'>{txn.txnType}</td>
                <td className='amt g_text_right'>{txn.txnTotalF4}</td>
              </tr>
            )
          }
          <tr><td colSpan='2'>&nbsp;</td></tr>
          <tr><td colSpan='2'><b>Add: Escrow Inflows</b></td></tr>
          {
            txnTypeInflowList && txnTypeInflowList.map((txn) =>
              <tr>
                <td className='name g_no_wrap_2'>{txn.txnType}</td>
                <td className='amt g_text_right'>{txn.txnTotalF4}</td>
              </tr>
            )
          }
          <tr><td colSpan='2'>&nbsp;</td></tr>
          <tr><td colSpan='2'><b>Less: Non-escrow Outflows</b></td></tr>
          {
            climeTypeOutflowList && climeTypeOutflowList.map((txn) =>
              <tr>
                <td className='name g_no_wrap_2'>{txn.txnType}</td>
                <td className='amt g_text_right'>{txn.txnTotalF4}</td>
              </tr>
            )
          }
          <tr><td colSpan='2'>&nbsp;</td></tr>
          <tr><td colSpan='2'><b>Less: Escrow Outflows</b></td></tr>
          {
            txnTypeOutflowList && txnTypeOutflowList.map((txn) =>
              <tr>
                <td className='name g_no_wrap_2'>{txn.txnType}</td>
                <td className='amt g_text_right'>{txn.txnTotalF4}</td>
              </tr>
            )
          }
          <tr><td colSpan='2'>&nbsp;</td></tr>
          <tr><td colSpan='2'><b>Closing Balances</b></td></tr>
          {
            cashFlow &&
            <>
              <tr>
                <td className='name g_no_wrap_2'>FDs</td>
                <td className='amt g_text_right'>{cashFlow.closingFdF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Bank statements</td>
                <td className='amt g_text_right'>{cashFlow.closingBalanceF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Restricted balance</td>
                <td className='amt g_text_right'>{cashFlow.closingRestrictedBalanceF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Unrestricted DSRA</td>
                <td className='amt g_text_right'>{cashFlow.closingUnrestrictedDSRAF4}</td>
              </tr>
              <tr>
                <td className='name g_no_wrap_2'>Unrestricted others</td>
                <td className='amt g_text_right'>{cashFlow.closingUnrestrictedOthersF4}</td>
              </tr>
            </>
          }
        </tbody>
      </table>
    </CardUI>

    <CashFlowDownloadModalSF context={context}
      downloadMode={downloadCFMode} onCancelClick={onDownloadCFCancel}
      onRefreshClick={onRefreshClick}
    />
    <ClientWiseSummaryDownloadModalSF context={context} accountNumber={accountNumber}
      downloadMode={downloadMode} onCancelClick={onDownloadCancel}
      onRefreshClick={onRefreshClick}
    />
  </div>

const ActionLeftUI = ({ onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Cash Flow in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ context, startDate, onStartDateChange, endDate, onEndDateChange, onSubmit }) =>
  <div className='g_flex_h'>
    <span className='g_m_left_50'><DatePickerSF context={context} selectedDateISO={startDate} onChange={onStartDateChange} placeholder='Start date' /></span>
    <span className='g_m_left_50'><DatePickerSF context={context} selectedDateISO={endDate} onChange={onEndDateChange} placeholder='End date' /></span>
    <Link to='#' className='g_m_left_50' onClick={onSubmit}>Submit</Link>
  </div>

export default NodalCashFlowUI
